(function(){
  if(window.__buceEmptyCartFinderBound)return;
  window.__buceEmptyCartFinderBound=true;

  var buceCatalogPromise=null;
  var buceCatalog=null;

  function buceTags(product){
    if(Array.isArray(product&&product.tags))return product.tags.map(function(x){return String(x).trim();});
    if(typeof (product&&product.tags)==="string")return product.tags.split(",").map(function(x){return x.trim();}).filter(Boolean);
    return [];
  }

  function buceHasTag(product,tag){
    return buceTags(product).some(function(x){return x.toLowerCase()===String(tag).toLowerCase();});
  }

  function buceAvailableVariants(product){
    return (product&&product.variants||[]).filter(function(variant){return variant.available!==false;});
  }

  function buceVariantText(variant){
    return [variant.title,variant.option1,variant.option2,variant.option3].filter(Boolean).join(" ");
  }

  function buceShoeSize(variant){
    var match=buceVariantText(variant).match(/(?:EUR\s*)?(3[4-9]|4[0-6])\b/i);
    return match?match[1]:"";
  }

  function buceIsShoe(product){
    var type=String(product&&product.product_type||"").toLowerCase().trim();
    var knownTypes=["zapatillas","nk","nike","nb","jdan","nk sb","dg","lv","adds","d'or","vns","pma","ow","on","ascs","bape","salomon","vsace","jordan","puma","sneakers","skechers","adidas","lecoq"];
    if(knownTypes.indexOf(type)>=0)return true;
    var tags=buceTags(product).map(function(x){return x.toLowerCase();});
    var shoeTags=["nk","adds","nb","jdn","pma","dg","lv","ascs","vns","vnns","offwt","on cloud","vsace","bape"];
    return shoeTags.some(function(tag){return tags.indexOf(tag)>=0;});
  }

  function buceLoadCatalog(){
    if(buceCatalogPromise)return buceCatalogPromise;
    buceCatalogPromise=fetch("/collections/all/products.json?limit=250",{credentials:"same-origin",cache:"no-store"})
      .then(function(response){if(!response.ok)throw new Error("catalog");return response.json();})
      .then(function(data){
        buceCatalog=(data&&data.products)||[];
        document.querySelectorAll("[data-buce-empty-finder]").forEach(function(root){buceRefreshShoeSizes(root);});
        return buceCatalog;
      })
      .catch(function(){buceCatalog=null;return null;});
    return buceCatalogPromise;
  }

  function buceRefreshShoeSizes(root){
    if(!root||!buceCatalog)return;
    var sizes=new Set();
    buceCatalog.filter(buceIsShoe).forEach(function(product){
      buceAvailableVariants(product).forEach(function(variant){
        var size=buceShoeSize(variant);
        if(size)sizes.add(size);
      });
    });
    root.querySelectorAll("[data-buce-shoe-size]").forEach(function(button){
      button.hidden=!sizes.has(button.getAttribute("data-buce-shoe-size"));
    });
  }

  function buceRefreshBrands(root,size){
    if(!root||!buceCatalog)return;
    var products=buceCatalog.filter(function(product){
      return buceIsShoe(product)&&buceAvailableVariants(product).some(function(variant){
        return buceShoeSize(variant)===String(size);
      });
    });
    root.querySelectorAll("[data-buce-brand]").forEach(function(button){
      var brand=button.getAttribute("data-buce-brand")||"";
      if(!brand){button.hidden=false;return;}
      button.hidden=!products.some(function(product){return buceHasTag(product,brand);});
    });
  }

  function track(action,detail){
    try{
      if(window.dataLayer){
        window.dataLayer.push({
          event:"buce_empty_cart_finder",
          action:action,
          detail:detail||""
        });
      }
      document.dispatchEvent(new CustomEvent("buce:empty-cart-finder",{detail:{action:action,detail:detail||""}}));
    }catch(e){}
  }

  function getRoot(target){
    return target&&target.closest?target.closest("[data-buce-empty-finder]"):null;
  }

  function show(root,step){
    root.dataset.step=step;
    root.querySelectorAll("[data-step-panel]").forEach(function(panel){
      panel.hidden=panel.getAttribute("data-step-panel")!==step;
    });
  }

  function markSelected(groupSelector,button){
    var wrap=button.closest(groupSelector);
    if(!wrap)return;
    wrap.querySelectorAll(".buce-empty-finder__chip").forEach(function(el){el.classList.remove("is-selected");});
    button.classList.add("is-selected");
  }

  function result(root,category){
    var url="/collections/all";
    var label="Ver mis opciones";
    var summary="";
    var params=new URLSearchParams();

    if(category==="shoes"){
      var size=root.dataset.shoeSize||"";
      var brand=root.dataset.brand||"";
      var brandLabel=root.dataset.brandLabel||"Todas";
      if(size)params.set("filter.v.option.talla","EUR "+size);
      var base=brand?"/collections/all/"+encodeURIComponent(brand):"/collections/all";
      url=base+(params.toString()?"?"+params.toString():"");
      summary="Zapatillas · Talla "+size+" · "+brandLabel;
      label="Ver zapatillas";
    }else if(category==="shirts"){
      var shirtSize=root.dataset.shirtSize||"";
      if(shirtSize)params.set("filter.v.option.talla",shirtSize);
      url="/collections/august"+(params.toString()?"?"+params.toString():"");
      summary="Camisetas August · Talla "+shirtSize;
      label="Ver camisetas";
    }else if(category==="caps"){
      params.set("filter.p.tag","CAPS");
      url="/collections/nrw?"+params.toString();
      summary="Gorras NRW";
      label="Ver gorras";
    }

    var summaryEl=root.querySelector("[data-buce-summary]");
    var link=root.querySelector("[data-buce-result-link]");
    if(summaryEl)summaryEl.textContent=summary;
    if(link){
      link.href=url;
      link.textContent=label;
      link.dataset.buceCategory=category;
    }
    show(root,"result");
  }

  document.addEventListener("click",function(event){
    var button=event.target.closest("button,a");
    if(!button)return;
    var root=getRoot(button);
    if(!root)return;

    if(button.matches("[data-buce-category]")){
      var category=button.getAttribute("data-buce-category");
      root.dataset.category=category;
      track("category",category);
      if(category==="shoes"){
        buceLoadCatalog().then(function(){buceRefreshShoeSizes(root);show(root,"shoe-size");});
      }else if(category==="shirts")show(root,"shirt-size");
      else result(root,"caps");
      return;
    }

    if(button.matches("[data-buce-shoe-size]")){
      var shoeSize=button.getAttribute("data-buce-shoe-size");
      root.dataset.shoeSize=shoeSize;
      markSelected(".buce-empty-finder__chips",button);
      track("shoe_size",shoeSize);
      buceLoadCatalog().then(function(){buceRefreshBrands(root,shoeSize);show(root,"shoe-brand");});
      return;
    }

    if(button.matches("[data-buce-brand]")){
      var brand=button.getAttribute("data-buce-brand");
      var brandLabel=button.getAttribute("data-buce-brand-label")||button.textContent.trim();
      root.dataset.brand=brand;
      root.dataset.brandLabel=brandLabel;
      markSelected(".buce-empty-finder__chips",button);
      track("brand",brandLabel);
      result(root,"shoes");
      return;
    }

    if(button.matches("[data-buce-shirt-size]")){
      var shirtSize=button.getAttribute("data-buce-shirt-size");
      root.dataset.shirtSize=shirtSize;
      markSelected(".buce-empty-finder__chips",button);
      track("shirt_size",shirtSize);
      result(root,"shirts");
      return;
    }

    if(button.matches("[data-buce-back]")){
      show(root,button.getAttribute("data-buce-back"));
      track("back",button.getAttribute("data-buce-back"));
      return;
    }

    if(button.matches("[data-buce-restart]")){
      root.dataset.category="";
      root.dataset.shoeSize="";
      root.dataset.shirtSize="";
      root.dataset.brand="";
      root.dataset.brandLabel="";
      root.querySelectorAll(".is-selected").forEach(function(el){el.classList.remove("is-selected");});
      show(root,"category");
      track("restart","");
      return;
    }

    if(button.matches("[data-buce-result-link]")){
      track("result_click",button.dataset.buceCategory||root.dataset.category||"");
      return;
    }

    if(button.matches("[data-buce-quick-link]")){
      track("quick_link","best_sellers");
    }
  },false);
})();